import { gql } from "@apollo/client";

export const GET_ALL_QUOTES = gql`
  query GetAllQuotes {
    getAllQuotes {
      id
      date
      user {
        id
        email
        name
        company
      }
      isNew
      status
      userDelete
      adminDelete
      companyName
      userName
      orderList {
        product {
          id
          modelNum
          type
          ... on PowerQuality {
            series
          }
          ... on SPD {
            series
          }
        }
        amount
      }
    }
  }
`;

export const GET_MY_CART = gql`
  query GetMyCart($id: ID!) {
    getMyCart(id: $id) {
      id
      orderList {
        product {
          id
          modelNum
          type
          ... on PowerQuality {
            series
          }
          ... on SPD {
            series
          }
        }
        amount
      }
    }
  }
`;

export const GET_MY_QUOTE = gql`
  query GetMyQuote($id: ID!) {
    getMyQuote(id: $id) {
      id
      date
      user {
        id
        email
        name
        company
      }
      userName
      companyName
      isNew
      status
      userDelete
      adminDelete
      orderList {
        product {
          id
          modelNum
          type
          ... on PowerQuality {
            series
          }
          ... on SPD {
            series
          }
        }
        amount
      }
    }
  }
`;

export const GET_QUOTE_BY_ID = gql`
  query GetQuoteByID($id: ID!) {
    getQuoteByID(id: $id) {
      id
      date
      user {
        id
        email
        name
        company
      }
      isNew
      status
      userDelete
      adminDelete
      userName
      userEmail
      companyName
      userPhoneNumber
      orderList {
        product {
          id
          modelNum
          type
          ... on PowerQuality {
            series
          }
          ... on SPD {
            series
          }
        }
        amount
      }
    }
  }
`;
